(function() {
    "use strict";

    function patchDownloadIcon(container) {
        const screenshotButton = container.querySelector('[data-action="screenshot"]');
        if (!screenshotButton || screenshotButton.dataset.downloadIconPatched === "true") return;

        screenshotButton.innerHTML = `
          <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
            <path d="M11 4h2v8.17l2.59-2.58L17 11l-5 5-5-5 1.41-1.41L11 12.17V4zM5 18h14v2H5z"></path>
          </svg>
        `;
        screenshotButton.dataset.downloadIconPatched = "true";
    }

    function setupColorNavigator(container) {
        const colorRow = container.querySelector(".nail-builder__mobile-row--colors");
        const colorScroll = container.querySelector("#mobileColorScroll");
        if (!colorRow || !colorScroll || colorRow.dataset.navReady === "true") return;

        const paintTool = colorRow.querySelector(".nail-builder__paint-tool");
        const depthTool = colorRow.querySelector(".nail-builder__depth-tool");
        const depthMeter = colorRow.querySelector("#depthMeter");
        const picker = colorRow.querySelector(".nail-builder__mobile-color-picker");
        const prev = document.createElement("button");
        prev.type = "button";
        prev.className = "nail-builder__mobile-color-arrow nail-builder__mobile-color-arrow--prev";
        prev.setAttribute("aria-label", "Scroll colors left");
        prev.textContent = "‹";

        const next = document.createElement("button");
        next.type = "button";
        next.className = "nail-builder__mobile-color-arrow nail-builder__mobile-color-arrow--next";
        next.setAttribute("aria-label", "Scroll colors right");
        next.textContent = "›";

        const shell = document.createElement("div");
        shell.className = "nail-builder__mobile-color-shell";
        const selectedIndicator = document.createElement("span");
        selectedIndicator.className = "nail-builder__mobile-color-selected-indicator";
        selectedIndicator.setAttribute("aria-hidden", "true");

        colorScroll.parentElement?.removeChild(colorScroll);
        shell.appendChild(colorScroll);

        if (picker) {
            picker.parentElement?.removeChild(picker);
            picker.classList.add("nail-builder__mobile-color-picker--detached");
        }
        shell.appendChild(selectedIndicator);

        colorRow.innerHTML = "";
        if (paintTool) colorRow.appendChild(paintTool);
        if (depthTool) colorRow.appendChild(depthTool);
        if (depthMeter) colorRow.appendChild(depthMeter);
        colorRow.appendChild(prev);
        colorRow.appendChild(shell);
        if (picker) colorRow.appendChild(picker);
        colorRow.appendChild(next);

        const hideSelectedIndicator = () => {
            selectedIndicator.classList.remove("is-visible");
        };

        const sync = () => {
            const maxLeft = Math.max(0, colorScroll.scrollWidth - colorScroll.clientWidth);
            const hasOverflow = maxLeft > 1;
            prev.disabled = !hasOverflow || colorScroll.scrollLeft <= 1;
            next.disabled = !hasOverflow || colorScroll.scrollLeft >= maxLeft - 1;

            if (!hasOverflow) {
                hideSelectedIndicator();
                return;
            }

            const selectedSwatch = colorScroll.querySelector(".nail-builder__mobile-color-swatch.active");
            if (!selectedSwatch) {
                hideSelectedIndicator();
                return;
            }

            const viewportRect = colorScroll.getBoundingClientRect();
            const selectedRect = selectedSwatch.getBoundingClientRect();
            const isVisibleInViewport = selectedRect.right > viewportRect.left + 1
                && selectedRect.left < viewportRect.right - 1;

            if (isVisibleInViewport) {
                hideSelectedIndicator();
                return;
            }

            const side = selectedRect.right <= viewportRect.left ? "left" : "right";
            const shellRect = shell.getBoundingClientRect();
            const indicatorX = side === "left"
                ? viewportRect.left - shellRect.left + 5
                : viewportRect.right - shellRect.left - 5;

            selectedIndicator.style.left = `${Math.round(indicatorX)}px`;
            selectedIndicator.style.setProperty(
                "--nb-selected-swatch-color",
                selectedSwatch.dataset.color || window.getComputedStyle(selectedSwatch).backgroundColor || "#d4bfb0"
            );
            selectedIndicator.dataset.side = side;
            selectedIndicator.classList.add("is-visible");
        };

        let syncRaf = null;
        const scheduleSync = () => {
            if (syncRaf !== null) return;
            syncRaf = requestAnimationFrame(() => {
                syncRaf = null;
                sync();
            });
        };

        prev.addEventListener("click", () => {
            colorScroll.scrollBy({ left: -80, behavior: "smooth" });
            scheduleSync();
        });

        next.addEventListener("click", () => {
            colorScroll.scrollBy({ left: 80, behavior: "smooth" });
            scheduleSync();
        });

        const swatchStateObserver = new MutationObserver(() => scheduleSync());
        swatchStateObserver.observe(colorScroll, {
            subtree: true,
            childList: true,
            attributes: true,
            attributeFilter: ["class", "style"]
        });

        if (typeof ResizeObserver === "function") {
            const resizeObserver = new ResizeObserver(() => scheduleSync());
            resizeObserver.observe(colorRow);
            resizeObserver.observe(colorScroll);
        }

        colorScroll.addEventListener("scroll", scheduleSync, { passive: true });
        container.addEventListener("nailbuilder:mobile-color-selection-change", scheduleSync);
        window.addEventListener("resize", scheduleSync, { passive: true });
        window.addEventListener("orientationchange", scheduleSync, { passive: true });
        colorRow.dataset.navReady = "true";
        scheduleSync();
        setTimeout(scheduleSync, 120);
        setTimeout(scheduleSync, 260);
    }

    function updateViewportVar() {
        document.documentElement.style.setProperty("--nb-local-mobile-vh", `${window.innerHeight}px`);
    }

    function ensureFrontPreview(builder) {
        const handWrapper = builder.container.querySelector("#handWrapper");
        if (!handWrapper) return null;

        let wrapper = handWrapper.querySelector(".nail-builder__mobile-front-preview");
        if (!wrapper) {
            wrapper = document.createElement("div");
            wrapper.className = "nail-builder__mobile-front-preview";

            const canvas = document.createElement("canvas");
            canvas.width = 84;
            canvas.height = 150;
            wrapper.appendChild(canvas);
            handWrapper.appendChild(wrapper);
        }

        return wrapper.querySelector("canvas");
    }

    async function renderFrontPreview(builder) {
        const canvas = ensureFrontPreview(builder);
        if (!canvas) return;

        const finger = builder.state.activeFinger || "thumb";
        const design = builder.state.nails[finger];
        if (!design) return;

        if (typeof builder.renderEditorCanvas === "function") {
            await builder.renderEditorCanvas(canvas);
        } else {
            await builder.renderNailToCanvas(canvas, finger, design, "strip");
        }

        const wrapper = canvas.closest(".nail-builder__mobile-front-preview");
        if (wrapper) {
            wrapper.classList.toggle("is-selected", builder.editorState?.selectedCharm !== null);


        }
    }

    function patchBuilder(builder) {
        if (!builder || builder.__localMobilePatchApplied) return;

        const originalRenderNailsOnHand = builder.renderNailsOnHand
            ? builder.renderNailsOnHand.bind(builder)
            : null;
        const originalRenderAllPreviews = builder.renderAllPreviews
            ? builder.renderAllPreviews.bind(builder)
            : null;
        const originalSelectFinger = builder.selectFinger
            ? builder.selectFinger.bind(builder)
            : null;

        builder.renderNailsOnHand = async function() {
            if (originalRenderNailsOnHand) {
                await originalRenderNailsOnHand();
            }

            if (!window.matchMedia("(max-width: 900px)").matches) return;
        };

        builder.renderAllPreviews = async function() {
            if (originalRenderAllPreviews) {
                await originalRenderAllPreviews();
            }
            await renderFrontPreview(this);
        };

        builder.selectFinger = function(finger) {
            if (originalSelectFinger) {
                originalSelectFinger(finger);
            }
            renderFrontPreview(this);
        };

        patchDownloadIcon(builder.container);
        setupColorNavigator(builder.container);
        const frontPreviewCanvas = ensureFrontPreview(builder);
        if (frontPreviewCanvas && typeof builder.bindEditorCanvas === "function") {
            builder.bindEditorCanvas(frontPreviewCanvas);
        }
        renderFrontPreview(builder);
        builder.renderNailsOnHand();
        builder.__localMobilePatchApplied = true;
    }

    function patchAllBuilders() {
        document.querySelectorAll("[data-nail-builder]").forEach((container) => {
            if (container.nailBuilder) {
                patchBuilder(container.nailBuilder);
            }
        });
    }

    document.addEventListener("DOMContentLoaded", () => {
        updateViewportVar();
        patchAllBuilders();

        const patchTimer = setInterval(() => {
            patchAllBuilders();
            const pending = Array.from(document.querySelectorAll("[data-nail-builder]"))
                .some((container) => !container.nailBuilder || !container.nailBuilder.__localMobilePatchApplied);
            if (!pending) {
                clearInterval(patchTimer);
            }
        }, 250);

        window.addEventListener("resize", updateViewportVar, { passive: true });
        window.addEventListener("orientationchange", updateViewportVar, { passive: true });
    });
})();
